/**
 * While true, useAuth0ServerLogin must not write tokens back to localStorage.
 * Prevents a race where logout clears storage but a refetch/in-flight query restores it.
 */
export const logoutState = {
  blockAuth0ServerSessionWrite: false,
};

export function beginAppLogout() {
  logoutState.blockAuth0ServerSessionWrite = true;
}

export function endAppLogoutBlock() {
  logoutState.blockAuth0ServerSessionWrite = false;
}
